import { render } from "./approval.vue?vue&type=template&id=f5a37790&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"

import "./approval.vue?vue&type=style&index=0&id=f5a37790&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a37790"]])

export default __exports__